<div class="file-upload fw">
  <div class="ub ub-ac mb15" v-if="allowEdit">
    <a-upload
      :before-upload="beforeUpload"
      :custom-request="customRequest"
      :multiple="true"
      :show-upload-list="false"
      name="file"
    >
      <a-button :disabled="disabled" :loading="uploading" type="primary"> 上传附件 </a-button>
    </a-upload>
    <div class="ub">
      <div class="text-grey ml15">（已选择{{ fileList?.length }}个文件）</div>
      <small class="ub ub-ac">附件上限{{ maxCount }}个，单个文件不得超过{{ maxSize }}M</small>
    </div>
  </div>
  <div class="file-upload-table">
    <table-wrapper
      ref="tableRef"
      :class="class"
      :tableHeight="fileList?.length>0?(fileList.length+2)*34:34*5"
      :dataSource="fileList"
      :columns="columns"
      :showCheckbox="false"
    >
      <template #size="{ record }">
        <span>{{ $filters.humanizeFileSize(record.size) }}</span>
      </template>
      <template #status="{ record }">
        <file-status :status="record.status"></file-status>
      </template>
      <template #action="{ record }">
        <hmd-empty-link v-if="allowEdit" @click="deleteFile(record)"> 删除 </hmd-empty-link>
        <!-- <hmd-empty-link @click="openPreview(record.url)"> 预览 </hmd-empty-link> -->
        <download-file :url="record.url" :fileName="record.name">下载</download-file>
      </template>
    </table-wrapper>
  </div>
</div>
